module.exports = __webpack_public_path__ + "img/0.49e37a4d.png";